import { render } from "./HeroiconsSolidChevronDoubleDown.vue?vue&type=template&id=15d4ad2b"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChevronDoubleDown.vue"]])

export default __exports__